<template>
  <div id="app">
    <img alt="Vue logo" src="https://gif.toutimages.com/images/fete/bonne_fete/bonne_fetes_002.gif">
    <HelloWorld msg="BonneFete Alexandre Marcotte"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background-color: rgba(255,255,255,0.9);
  max-width: 500px;;
  margin: 100PX auto
}
body{
    background-image: url('https://www.thesun.co.uk/wp-content/uploads/2016/10/cattt.jpg');
    background-size:50px;
}

</style>
